module.exports = __webpack_public_path__ + "img/logo-epos.eed6345d.png";